export default "__VITE_ASSET__iB5ck4kG__"